<template>
  <v-app id="landing-page" :style="{ 'background-color': colorEBikeBarraFormulario }">
    <v-main class="#212226 mx-4 mt-6">
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";

export default {
  name: "App",

  components: {
  },

  data: () => ({
  }),

  computed: {
    ...mapState("auth", ["user", "access_token"]),
    ...mapState([
      "loading",
      "drawer",
      "dark",

      "colorEBikeFondo",
      "colorEBikeBarraFormulario",
      "colorEBikeAccent1",


      "colorFondo500",
      "colorFondo400",
      "colorFondo300",
      "colorFondo200",
      "colorFondo100",

      "colorFront500",
      "colorFront400",
      "colorFront300",
      "colorFront200",
      "colorFront100",

      "colorAccent2",
      "colorAccent1",
    ]),
     
  },

  mounted() {
    this.$router.push("/login");
  },

  methods: {
    ...mapActions("auth", ["logOut"]),
    
    
    async _logout() {
      await this.logOut([this.access_token]);
      this.$router.push("/login");
    },
  },
};
 // background-image: url("./assets/fondo5.jpg");

 /*
 <html lang="en" class="notranslate" translate="no"> 
<head>
  <meta name="google" content="notranslate" /> 
</head>
<body class="notranslate"> 

 */
</script>

<style>
@import url("https://fonts.googleapis.com/css?family=Noto+Sans:400,600,300");

@font-face {
  font-family: "Noto";
  src: local("Noto"),
    url(./fonts/noto-sans-v26-latin-regular.ttf) format("truetype");
}

* {
  text-transform: none !important;
}

#landing-page {
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  font-family: 'Noto';
  
}

html {
  overflow: auto !important;
}

.v-data-table-header {
  background-color: grey;
}
</style>